/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { ECommerce, ProductPage } from "../../../Constant";
import { useEffect } from "react";
import axios from "axios";
import { ProductsApi } from "../../../api";
import { useAppDispatch } from "../../../Redux-Toolkit/Hooks";
import { setProductItem } from "../../../Redux-Toolkit/Reducers/ProductSlice";
import ImageSlider from "./ImageSilder";
import ProductDetails from "./ProductDetails/ProductDetails";
import BrandDetail from "./BrandDetail";
import ClothsDetails from "./ClothsDetails";
import { toast } from "react-toastify";

const ProductPageContainer = () => {
  const dispatch = useAppDispatch();
  const fetchProducts = async () => {
    try {
      await axios.get(ProductsApi).then((resp) => {
        dispatch(setProductItem(resp.data));
      });
    } catch (error) {
      toast.error("error"+ error);
    }
  };
  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <>
      <Breadcrumbs pageTitle={ProductPage} parent={ECommerce} title={ProductPage} />
      <Container fluid>
        <div>
          <Row>
            <ImageSlider />
            <ProductDetails/>
            <BrandDetail/>
          </Row>
          <Card>
            <Row className="product-page-main">
              <ClothsDetails/>
            </Row>
          </Card>
        </div>
      </Container>
    </>
  );
};
export default ProductPageContainer;
